<div mat-dialog-content>
  <h3>{{message}}</h3>
</div>
<div mat-dialog-actions>
  <button class="button button-stackoverflow button-xs" (click)="onYesClick()">Conferma</button>
  <button class="button button-lastfm button-xs ml-1" (click)="onNoClick()">Annulla</button>
</div>
